/* eslint-disable */
import React, { ReactElement, useEffect, useState } from "react";
import { Box, Skeleton, Button } from "@mui/material";
import { MdOutlineVisibility } from "react-icons/md";
import { useRecruiters } from "src/hooks/query/recruiters";
import { Loader } from "src/components";
import { UploadIcon } from "src/icons";
import { useLocations } from "src/hooks/query/locations";
import useSkills from "src/hooks/query/skills";
import { useClients } from "src/hooks/query/clients";
import { File } from "src/components/elements";
import {
  FileFormat,
  FileValueType,
  getConcatinatedSupportFiles,
  getFileSize,
} from "src/components/elements/File";
import {
  Description,
  InlineInput,
  InlineSelect,
  InlineMultiSelect,
  ResumeTabs,
  Notes,
} from "../../components";
import { getFileIcon, getFileName } from "../../../CandidateDocuments/utils";
import styles from "./Desktop.module.css";
import {
  NumericOption,
  Option,
  UpdateJobDescription,
  UpdateJobDetailType,
  UpdateJobDetails,
  UpdateJobLocation,
  UpdateOthersTab,
  UpdateOthersTabType,
  UpdateRecruiters,
  UpdateSkills,
  ViewJobViewRendererProps,
} from "../../types";
import {
  options as currencyOptions,
  Option as CurrencyOption,
} from "src/components/elements/Input";
import { FaCircleExclamation } from "react-icons/fa6";

const requirementTypesOptions: Option[] = [
  { value: "directClient", label: "Client" },
  { value: "Direct-Client", label: "Client" },
  { value: "benchSales", label: "Bench-Sales" },
  { value: "Bench-Sales", label: "Bench-Sales" },
  { value: "c2c", label: "C2C" },
  { value: "C2C", label: "C2C" },
  { value: "internal", label: "Internal" },
];

const jobTypeOptions: Option[] = [
  { value: "contractHire", label: "Contract-hire" },
  { value: "FullTime", label: "Full Time" },
  { value: "Contract", label: "Contract" },
  { value: "intern", label: "Intern"},
  { value: 'internHire', label: 'Intern-hire' },
];

const payRateTypeOptions: Option[] = [
  { value: "hourly", label: "Hourly" },
  { value: "monthly", label: "Monthly" },
  { value: "annually", label: "Annually" },
];

const jobStatusOptions: Option[] = [
  { label: "Active", value: "ACTIVE" },
  { label: "Archived", value: "ARCHIEVED" },
  { label: "Halted", value: "HALTED" },
  { label: "Do Not Work", value: "DO_NOT_WORK" },
];

const jobDurationPeriodOptions: Option[] = [
  { label: "Days", value: "days" },
  { label: "Months", value: "months" },
  { label: "Years", value: "years" },
];

const getLocationsValue = (
  locationValues: { name: string }[] = [],
  locationOptions: Option[] = []
) => {
  const locationsArr = locationValues?.map(({ name }) => name);
  const locationsValue = locationOptions?.filter(({ value }) =>
    locationsArr?.includes(value)
  );
  return locationsValue;
};

const getRecruitersValue = (
  recruiterValues: { recruiterId: number }[] = [],
  recruiterOptions: NumericOption[] = []
) => {
  const recruiterArr = recruiterValues?.map(({ recruiterId }) => recruiterId);
  const recruiterValue = recruiterOptions.filter(({ value }) =>
    recruiterArr.includes(value)
  );
  return recruiterValue;
};

const getValueFromOptions = (values: Option[]) =>
  values.map(({ value }) => value);

const getNumericValueFromOptions = (values: NumericOption[]) =>
  values.map(({ value }) => value);

const getIcon = (fileName: string): ReactElement => {
  const Component = getFileIcon(fileName);
  return <Component className="w-6 h-6 text-secondary" />;
};

const JobDetailsSkelton = function () {
  return (
    <Box className="grow-0 shrink-0 basis-[70%] overflow-hidden">
      <Box className="text-left pt-5 pb-3">
        <Box className="bg-white rounded">
          <Box className="flex flex-wrap divide-x-2">
            <Box className="relative basis-1/4 py-5 px-5">
              <Box className="absolute left-0 top-0 h-[4px] w-full bg-[#F97171] rounded-full" />
              <Box className="text-xl leading-[22px]">
                <Skeleton />
              </Box>
            </Box>
            <Box className="relative basis-1/4 py-5 px-5">
              <Box className="absolute left-0 top-0 h-[4px] w-full bg-[#F9C371] rounded-full" />
              <Box className="text-xl leading-[22px]">
                <Skeleton />
              </Box>
            </Box>
            <Box className="relative basis-1/4 py-5 px-5">
              <Box className="absolute left-0 top-0 h-[4px] w-full bg-[#66D392] rounded-full" />
              <Skeleton />
            </Box>
            <Box className="relative basis-1/4 py-5 px-5">
              <Box className="absolute left-0 top-0 h-[4px] w-full bg-[#4C7D94] rounded-full" />
              <Box className="text-xl leading-[22px]">
                <Skeleton />
              </Box>
            </Box>
          </Box>

          <Box
            className="flex flex-wrap mx-5"
            sx={{
              borderTop: 2,
              borderColor: "#EAEBED",
            }}
          >
            <Box className="basis-1/3 py-5 pr-5">
              <Skeleton />
            </Box>
            <Box className="basis-1/3 py-5 px-5">
              <Skeleton />
            </Box>

            <Box className="basis-1/3 py-5 pl-5">
              <Skeleton />
            </Box>
          </Box>
          <Box
            className="flex gap-10 py-5 mx-5"
            sx={{
              borderTop: 2,
              borderColor: "#EAEBED",
            }}
          >
            <Box className="basis-1/4">
              <Skeleton />
            </Box>
            <Box className="basis-1/4">
              <Skeleton />
            </Box>
            <Box className="basis-1/4">
              <Skeleton />
            </Box>
            <Box className="basis-1/4">
              <Skeleton />
            </Box>
          </Box>
        </Box>
      </Box>

      <Box className="text-left pt-5 pb-3 border-r-8">
        <Box className="font-bold text-sm leading-5 pb-1">Notes</Box>
        <div className="w-full  p-6 flex gap-4 flex-col bg-white">
          <Skeleton className="h-[30px] w-[20%] mt-2" />
          <Skeleton className="h-[20px] w-[60%]" />

          <Skeleton className="h-[30px] w-[20%] mt-2" />
          <Skeleton className="h-[20px] w-[60%]" />
        </div>
      </Box>

      <Box className="text-left pt-5 pb-3 border-r-8">
        <Box className="font-bold text-sm leading-5 pb-1">Description</Box>
        <div className="w-full p-6 flex gap-4 flex-col bg-white">
          <Skeleton className="h-[40px] w-[50%]" />
          <Skeleton className="h-[30px] w-[40%]" />
          <Skeleton className="h-[42px] w-[60%]" />
        </div>
      </Box>
    </Box>
  );
};

function Desktop(props: ViewJobViewRendererProps) {
  const {
    fetchingJobDetails,
    loading,
    jobDetails,
    candidatesLoading,
    candidatesList,
    matchingResumeList,
    updateJobDetails,
    updateOthersTab,
    updateJobLocations,
    updateSkills,
    updateJobRecruiters,
    showCandidateDetailsForm,
    getCandidatesForJob,
    getMatchingResumes,
    updateJobDescription,
    addJobNotes,
    updateJobNotes,
    onClose,
    assignedToAll,
    setAssignedToAll,
    onDocumentView,
    tabValue,
    handleChangeTabValue,
  } = props;

  const [currencyOption, setCurrencyOption] = useState(
    currencyOptions.find(
      (option) => option.currencyName === jobDetails?.currency
    ) || { currencyName: "", currencyIcon: "" }
  );
  const [isBtnDisabled, setIsBtnDisabled] = useState<boolean>(false);

  useEffect(() => {
    setCurrencyOption(
      currencyOptions.find(
        (option) => option.currencyName === jobDetails?.currency
      ) || { currencyName: "", currencyIcon: "" }
    );
  }, [jobDetails]);

  const { recruitersWithEmailOptions, recruitersLoading } = useRecruiters();

  const { locationsOptions, locationsLoading } = useLocations();

  const { skillsLoading, skillsOptions } = useSkills();

  const { clientOptions } = useClients();

  const updateJobDetail = async (
    type: UpdateJobDetailType,
    value: string | number,
    confirmText: string
  ) => {
    const request: UpdateJobDetails = {
      jobOrderId: jobDetails?.jobOrderId,
    };

    switch (type) {
      case "clientId":
        request.clientId = value as number;
        break;
      case "jobTitle":
        request.jobTitle = value as string;
        break;
      case "requirementType":
        request.requirementType = value as string;
        break;
      case "vendor":
        request.vendor = value as string;
        break;
      default:
        throw new Error(`Unknown update type: ${type}`);
    }

    updateJobDetails(request, confirmText);
  };

  const updateOthersTabDetail = (
    type: UpdateOthersTabType,
    value: string,
    confirmText: string,
    currency?: CurrencyOption
  ) => {
    const request: UpdateOthersTab = {
      jobOrderId: jobDetails?.jobOrderId,
    };

    switch (type) {
      case "payRateMin":
        request.payRateMin = value;
        request.currency = currency?.currencyName;
        setCurrencyOption(currency || { currencyName: "", currencyIcon: "" });
        break;
      case "payRateMax":
        request.payRateMax = value;
        request.currency = currency?.currencyName;
        setCurrencyOption(currency || { currencyName: "", currencyIcon: "" });
        break;
      case "payRateType":
        request.payRateType = value;
        break;
      case "jobType":
        request.jobType = value;
        break;
      case "jobDuration":
        request.jobDuration = value;
        break;
      case "jobDurationPeriod":
        request.jobDurationPeriod = value;
        break;
      case "status":
        request.status = value;
        break;
      default:
        throw new Error(`Unknown update type: ${type}`);
    }

    updateOthersTab(request, confirmText);
  };

  const updateJobLocation = (value: Option[]) => {
    const request: UpdateJobLocation = {
      jobOrderId: jobDetails?.jobOrderId,
      jobLocations: getValueFromOptions(value),
    };
    updateJobLocations(request);
  };

  const updateRequiredSkills = (value: Option[]) => {
    const request: UpdateSkills = {
      jobOrderId: jobDetails?.jobOrderId,
      skills: getValueFromOptions(value),
    };
    updateSkills(request);
  };

  const updateCurrentRecruiters = (value: NumericOption[]) => {
    const request: UpdateRecruiters = {
      jobOrderId: jobDetails?.jobOrderId,
      recruiters: getNumericValueFromOptions(value),
    };
    updateJobRecruiters(request);
  };

  const updateDescription = (value: string) => {
    const request: UpdateJobDescription = {
      jobOrderId: jobDetails?.jobOrderId,
      jobDescription: value,
    };
    updateJobDescription(request);
  };

  const handleButtonClick = () => {
    setIsBtnDisabled(true);
    showCandidateDetailsForm(null, false);
    setTimeout(() => setIsBtnDisabled(false), 3000);
  };

  return (
    <>
      <div className={styles.root}>
        <Box className="flex flex-row">
          {fetchingJobDetails ? (
            <JobDetailsSkelton />
          ) : jobDetails?.status === "UNAUTHORIZED" ? (
            <Box className="w-full h-[80vh] flex flex-col gap-2 items-center justify-center">
              <Box className="text-primary flex gap-2 items-center text-4xl justify-center">
                <FaCircleExclamation className="text-primary" />
                Un-Authorized
              </Box>
              <Box className="text-secondary">
                This job is not available in your current organization. Please
                switch to the correct organization to view it.
              </Box>
            </Box>
          ) : (
            <Box className="grow-0 shrink-0 basis-[70%] overflow-hidden">
              <Box className="text-left pt-5 pb-3">
                <Box className="bg-white rounded">
                  <Box className="flex flex-wrap divide-x-2">
                    <Box className="relative basis-1/4 py-5 px-5">
                      <Box className="absolute left-0 top-0 h-[4px] w-full bg-[#F97171] rounded-full" />
                      <Box className="text-xl leading-[22px]">
                        <InlineSelect
                          label="Client"
                          value={jobDetails?.clientId}
                          options={clientOptions}
                          confirmFunction={(value: number) => {
                            updateJobDetail("clientId", value, "Client");
                          }}
                          isEditable={false}
                        />
                      </Box>
                    </Box>
                    <Box className="relative basis-1/4 py-5 px-5">
                      <Box className="absolute left-0 top-0 h-[4px] w-full bg-[#F9C371] rounded-full" />
                      <Box className="text-xl leading-[22px]">
                        <InlineInput
                          value={jobDetails?.jobTitle}
                          label="Job Title"
                          confirmFunction={(value: string) => {
                            updateJobDetail("jobTitle", value, "Job Title");
                          }}
                        />
                      </Box>
                    </Box>
                    <Box className="relative basis-1/4 py-5 px-5">
                      <Box className="absolute left-0 top-0 h-[4px] w-full bg-[#66D392] rounded-full" />
                      <InlineSelect
                        value={jobDetails?.requirementType}
                        label="Requirement Type"
                        options={requirementTypesOptions}
                        confirmFunction={(value: string) => {
                          updateJobDetail(
                            "requirementType",
                            value,
                            "Requirement Type"
                          );
                        }}
                        isEditable={false}
                      />
                    </Box>
                    <Box className="relative basis-1/4 py-5 px-5">
                      <Box className="absolute left-0 top-0 h-[4px] w-full bg-[#4C7D94] rounded-full" />
                      <Box className="text-xl leading-[22px]">
                        <InlineInput
                          value={jobDetails?.vendor}
                          label="Vendor"
                          confirmFunction={(value: string) => {
                            updateJobDetail("vendor", value, "Vendor");
                          }}
                          isEditable={false}
                        />
                      </Box>
                    </Box>
                  </Box>

                  <Box
                    className="flex flex-wrap mx-5"
                    sx={{
                      borderTop: 2,
                      borderColor: "#EAEBED",
                    }}
                  >
                    <Box className="basis-1/3 py-5 pr-5">
                      <InlineMultiSelect
                        label="Locations"
                        options={locationsOptions || []}
                        loading={locationsLoading}
                        value={getLocationsValue(
                          jobDetails?.location,
                          locationsOptions
                        )}
                        confirmFunction={updateJobLocation}
                      />
                    </Box>

                    <Box className="basis-1/3 py-5 px-5">
                      <InlineMultiSelect
                        label="Skillset"
                        options={skillsOptions || []}
                        loading={skillsLoading}
                        value={getLocationsValue(
                          jobDetails?.skills,
                          skillsOptions
                        )}
                        confirmFunction={updateRequiredSkills}
                      />
                    </Box>

                    <Box className="basis-1/3 py-5 pl-5">
                      <InlineMultiSelect
                        label="Recruiters"
                        options={recruitersWithEmailOptions || []}
                        loading={recruitersLoading}
                        value={getRecruitersValue(
                          jobDetails?.recruiters,
                          recruitersWithEmailOptions
                        )}
                        confirmFunction={updateCurrentRecruiters}
                      />
                    </Box>
                  </Box>

                  <Box
                    className="flex gap-10 py-5 mx-5"
                    sx={{
                      borderTop: 2,
                      borderColor: "#EAEBED",
                    }}
                  >
                    <Box className="basis-1/4">
                      <InlineInput
                        value={jobDetails.payRateMin}
                        currency={jobDetails?.currency}
                        currencyOption={currencyOption}
                        inlineLabel="Pay Rate (Min)"
                        confirmFunction={(
                          value: string,
                          currency: CurrencyOption
                        ) => {
                          updateOthersTabDetail(
                            "payRateMin",
                            value,
                            "Pay Rate (Min)",
                            currency
                          );
                        }}
                        showCurrencyOption
                      />
                    </Box>
                    <Box className="basis-1/4">
                      <InlineInput
                        value={jobDetails.payRateMax}
                        currency={jobDetails?.currency}
                        currencyOption={currencyOption}
                        inlineLabel="Pay Rate (Max)"
                        confirmFunction={(
                          value: string,
                          currency: CurrencyOption
                        ) => {
                          updateOthersTabDetail(
                            "payRateMax",
                            value,
                            "Pay Rate (Max)",
                            currency
                          );
                        }}
                        showCurrencyOption
                      />
                    </Box>
                    <Box className="basis-1/4">
                      <InlineSelect
                        value={jobDetails.payRateType}
                        inlineLabel="Pay Rate Type"
                        options={payRateTypeOptions}
                        confirmFunction={(value: string) => {
                          updateOthersTabDetail("payRateType", value, "Type");
                        }}
                      />
                    </Box>
                  </Box>
                  <Box
                    className="flex gap-10 py-5 mx-5"
                    sx={{
                      borderTop: 2,
                      borderColor: "#EAEBED",
                    }}
                  >
                    <Box className="basis-1/4">
                      <InlineSelect
                        value={jobDetails.jobType}
                        inlineLabel="Type"
                        options={jobTypeOptions}
                        confirmFunction={(value: string) => {
                          updateOthersTabDetail("jobType", value, "Type");
                        }}
                      />
                    </Box>
                    <Box className="basis-1/8">
                      <InlineInput
                        value={jobDetails.jobDuration}
                        inlineLabel="Duration"
                        isEditable={jobDetails.jobType !== "FullTime"}
                        disable={true}
                        confirmFunction={(value: string) => {
                          updateOthersTabDetail(
                            "jobDuration",
                            value,
                            "Job Duration"
                          );
                        }}
                      />
                    </Box>
                    <Box className="basis-1/4">
                      <InlineSelect
                        value={jobDetails.jobDurationPeriod}
                        isEditable={jobDetails.jobType !== "FullTime"}
                        inlineLabel="Duration Period"
                        options={jobDurationPeriodOptions}
                        confirmFunction={(value: string) => {
                          updateOthersTabDetail("jobDurationPeriod", value, "Duration Period");
                        }}
                      />
                    </Box>
                    <Box className="basis-1/4">
                      <InlineSelect
                        value={jobDetails.status}
                        inlineLabel="Status"
                        options={jobStatusOptions}
                        confirmFunction={(value: string) => {
                          updateOthersTabDetail("status", value, "Status");
                        }}
                      />
                    </Box>
                  </Box>
                  <Box
                    className="flex gap-10 py-5 mx-5"
                    sx={{
                      borderTop: 2,
                      borderColor: "#EAEBED",
                    }}
                  >
                    <Box className="basis-1/4">
                      <InlineInput
                        value={jobDetails.alternateJobId}
                        inlineLabel="Alternate Job Id"
                        isEditable={false}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>

              {jobDetails.documentsList && (
                <Box className="text-left pt-5 pb-3 border-r-8">
                  <Box className="font-bold text-sm leading-5 pb-1">
                    Document
                  </Box>
                  <Box className="bg-white p-5 my-1 rounded flex justify-between items-center	">
                    <div className="flex items-center">
                      {getIcon(jobDetails.documentsList?.documentURL || "")}
                    </div>
                    <div className="text-base break-all">
                      {jobDetails.jobId}
                    </div>

                    <Button
                      size="small"
                      className="text-secondary"
                      startIcon={<MdOutlineVisibility />}
                      onClick={() => onDocumentView(jobDetails.documentsList)}
                    >
                      Preview
                    </Button>
                  </Box>
                </Box>
              )}

              <Box className="text-left pt-5 pb-3 border-r-8">
                <Box className="font-bold text-sm leading-5 pb-1">Notes</Box>
                <Notes
                  value={jobDetails?.notes}
                  jobOrderId={jobDetails?.jobOrderId}
                  addJobNote={addJobNotes}
                  updateJobNote={updateJobNotes}
                />
              </Box>

              <Box className="text-left pt-5 pb-3 border-r-8">
                <Box className="font-bold text-sm leading-5 pb-1">
                  Description
                </Box>
                <Description
                  value={jobDetails.jobDescription}
                  confirmFunction={updateDescription}
                />
              </Box>
            </Box>
          )}
          {jobDetails?.status !== "UNAUTHORIZED" && (
            <Box className="grow-0 shrink-0 basis-[30%] mt-[-50px] mr-5 py-10 pt-0 p-5 overflow-x-hidden">
              <div className="fixed">
                <div className="border border-primary border-dashed rounded-lg">
                  <div className="bg-white rounded-lg">
                    <File
                      minSize={1}
                      maxSize={10000000}
                      supportTypes={{
                        [FileFormat.PDF]: [],
                        [FileFormat.JPG]: [],
                        [FileFormat.PNG]: [],
                        [FileFormat.DOC]: [],
                        [FileFormat.DOCX]: [],
                        [FileFormat.TXT]: [],
                      }}
                      onChange={(file: FileValueType) =>
                        showCandidateDetailsForm(file, true)
                      }
                      onClose={onClose}
                    >
                      <div className="flex flex-col py-4">
                        <div className="text-primary flex justify-center items-center">
                          <UploadIcon className="w-6 h-5" />
                          <span>Upload Resume</span>
                        </div>
                        <div className="text-xs">{`Accepted files ${getConcatinatedSupportFiles(
                          {
                            [FileFormat.DOC]: [],
                            [FileFormat.DOCX]: [],
                            [FileFormat.PDF]: [],
                            [FileFormat.JPG]: [],
                            [FileFormat.PNG]: [],
                            [FileFormat.TXT]: [],
                          }
                        )} < ${getFileSize(10000000)}`}</div>
                      </div>
                    </File>
                  </div>
                </div>
                <Button
                  variant="contained"
                  fullWidth
                  className="h-[40px] font-medium whitespace-nowrap rounded-lg mt-4"
                  size="small"
                  onClick={handleButtonClick}
                  disabled={isBtnDisabled}
                >
                  Add New Candidate
                </Button>
                <ResumeTabs
                  candidatesLoading={candidatesLoading}
                  candidatesList={candidatesList}
                  fetchCandidates={getCandidatesForJob}
                  jobOrderId={jobDetails?.jobOrderId}
                  getMatchingResumes={getMatchingResumes}
                  matchingResumeList={matchingResumeList}
                  assignedToAll={assignedToAll}
                  setAssignedToAll={setAssignedToAll}
                  tabValue={tabValue}
                  handleChangeTabValue={handleChangeTabValue}
                />
              </div>
            </Box>
          )}
        </Box>
      </div>
      {!fetchingJobDetails && loading && (
        <div className="fixed top-[50vh] left-[50vw]">
          <Loader />
        </div>
      )}
    </>
  );
}

export default Desktop;
